import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=3407c36c&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3407c36c')) {
      api.createRecord('3407c36c', component.options)
    } else {
      api.reload('3407c36c', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=3407c36c&", function () {
      api.rerender('3407c36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Ir3XrvhaBM/JS/comp/openstreetmap.vue"
export default component.exports